import { z } from 'zod';

export interface ApiNetworkResponse<T> {
    status: number;
    networkError: boolean;
    data: T;
}

export interface ApiSuccessResponse<T> extends ApiNetworkResponse<T> {
    error: false;
}

export interface ApiErrorResponse extends ApiNetworkResponse<{
    message: string;
}> {
    error: true;
}

export type ApiResponse<T> = ApiErrorResponse | ApiSuccessResponse<T>;

export interface ApiKeyResponse {
    api_key: string;
    expires: string;
}

export const paginatedQuerySchema = (options?: {
    default_per_page?: number;
    max_per_page?: number;
}) =>
    z.object({
        page: z.number().min(1).default(1).optional(),
        per_page: z
            .number()
            .max(options?.max_per_page ?? 100)
            .default(options?.default_per_page ?? 20)
            .optional(),
    });

export const defaultPaginatedQuery = paginatedQuerySchema().parse({});

export type PaginatedQuery = z.infer<ReturnType<typeof paginatedQuerySchema>>;

export interface PaginatedResponse<T> {
    data: T[];
    count: number;
    pages: number;
    page: number;
    per_page: number;
}
